const html = require("choo/html");
const TutorialPanel = require("./tutorial-panel.js");
function TutorialWrapper(state, emit) {
  let tutorialPanel = null;
  if (state.playingTutorial) {
    const tutorialStep = state.currentTutorial[state.currentTutorialStep];

    let anchorElement = document.querySelector("#gamescreen");
    let hidden = false;
    let marginX = 0, marginY = 0;
    let widthString = "width: 300rem;"
    let heightString = ""
    let x, y;
          // tutorial anchor position is the corner of the tutorial panel that should be positioned at the anchor element
          let tutorialAnchor = "top-right";
          // element anchor position is the corner of the anchor element that the tutorial panel should be positioned at
          let elementAnchor = "top-right";
    
    if (!anchorElement) {
      hidden = true;
      x = 0;
      y = 0;
    } else {
   if (tutorialStep.anchor) {
    anchorElement = document.getElementById(tutorialStep.anchor.element);
    tutorialAnchor = tutorialStep.anchor.tutorialAnchor;
    elementAnchor = tutorialStep.anchor.elementAnchor;
    if (tutorialStep.anchor.width){
      widthString = `width: ${tutorialStep.anchor.width}rem;`
    }
    if (tutorialStep.anchor.height){
      heightString = `height: ${tutorialStep.anchor.height}`
    }

    if (tutorialStep.anchor.marginX) {
      marginX = tutorialStep.anchor.marginX;
    }
    if (tutorialStep.anchor.marginY) {
      marginY = tutorialStep.anchor.marginY;
    }
  }


      const anchorElementBounds = anchorElement
        ? anchorElement.getBoundingClientRect()
        : { left: 0, right: 0, top: 0, bottom: 0 };
      let elementPositionX;
      let elementPositionY;
      switch (elementAnchor) {
        case "top-left":
          elementPositionX = anchorElementBounds.left;
          elementPositionY = anchorElementBounds.top;
          break;
        case "top-right":
          elementPositionX = anchorElementBounds.right;
          elementPositionY = anchorElementBounds.top;
          break;
        case "bottom-left":
          elementPositionX = anchorElementBounds.left;
          elementPositionY = anchorElementBounds.bottom;
          break;
        case "bottom-right":
          elementPositionX = anchorElementBounds.right;
          elementPositionY = anchorElementBounds.bottom;
          break;
      }
      const tutorialPanelElement = document.getElementById(
        "tutorial-panel-wrapper"
      );
      const tutorialPanelBounds = tutorialPanelElement
        ? tutorialPanelElement.getBoundingClientRect()
        : { width: 0, height: 0 };
      const marginXinPx = tutorialPanelBounds.width*marginX*.022;
      const marginYinPx = tutorialPanelBounds.height*marginY*.022;
      switch (tutorialAnchor) {
        case "top-left":
          x = elementPositionX + marginXinPx;
          y = elementPositionY + marginYinPx;
          break;
        case "top-right":
          x =
            elementPositionX -
            tutorialPanelBounds.width + marginXinPx;
          y = elementPositionY  + marginYinPx;
          break;
        case "bottom-left":
          x = elementPositionX + marginXinPx;
          y = elementPositionY- tutorialPanelBounds.height + marginYinPx;
          break;
        case "bottom-right":
          x = elementPositionX - tutorialPanelBounds.width + marginXinPx;
          y = elementPositionY - tutorialPanelBounds.height + marginYinPx;
          break;
      }
    }
    const appBounds = document.getElementById("app").getBoundingClientRect();

    x-=appBounds.left;
    y-=appBounds.top;
    tutorialPanel = html` <div
      id="tutorial-panel-wrapper"
      class="${state.isMenuOpen ? 'menu-hidden' : ''}"
      style="position:absolute; left: ${x}px; top: ${y}px;
      ${widthString} ${heightString}"
    >
      ${TutorialPanel(state, emit)}
    </div>`;
  }
  return tutorialPanel;
}

module.exports = TutorialWrapper;
